import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { DocumentHeadManager } from '@/components/common/DocumentHeadManager'
import '@workos-inc/widgets/styles.css'
import '@/styles/global.css'
import '@radix-ui/themes/styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <DocumentHeadManager />
    <RouterProvider router={router} />
  </>,
)
